// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDPdRkstZGl-SDwF_fUks2PCD8WATyOoOs",
  authDomain: "scontiassesment.firebaseapp.com",
  databaseURL: "https://scontiassesment-default-rtdb.firebaseio.com",
  projectId: "scontiassesment",
  storageBucket: "scontiassesment.firebasestorage.app",
  messagingSenderId: "900210922636",
  appId: "1:900210922636:web:8d83881660fd6f37aa57a9",
  measurementId: "G-MQ5LVV1BTM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore Database and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Initialize Analytics (optional, for web analytics)
export const analytics = getAnalytics(app);

export default app;
